<template>
  <div class="base-page">
    <!-- 1. 顶部Banner（复用公司介绍页Banner） -->
    <section class="relative w-full overflow-hidden">
      <img src="@/assets/about/Rectangle_50.png" alt="北京菌丰生物科技有限公司" class="w-full h-full object-cover">
      <div class="absolute inset-0 text-center top-[20%] text-white z-10">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">北京菌丰生物科技有限公司</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)] max-w-lg text-center px-4 mx-auto">
          农菌+科技双轮驱动，菌菇产业迎黄金增长期</p>
      </div>
      <div class="absolute inset-0 bg-black/30"></div>
    </section>

    <!-- 2. 基地介绍标题区 -->
    <section class="py-12 max-w-[56%] mx-auto px-4">
      <div class="flex justify-between items-center mb-8">
        <div class="flex items-center gap-2">
          <!-- <div class="w-5 h-5 bg-[#41B56F] rounded flex items-center justify-center">
            <span class="text-white text-xs">🏠</span>
          </div> -->
          <div class="flex items-end gap-2">
            <svg t="1776759580176" class="icon" viewBox="0 0 1042 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="14907" width="40" height="40">
              <path
                d="M956.342857 429.714286v-1.828572c-1.828571-3.657143-1.828571-5.485714-3.657143-7.314285v-1.828572c-1.828571-3.657143-3.657143-5.485714-7.314285-7.314286l-402.285715-329.142857c-12.8-10.971429-32.914286-10.971429-45.714285 0l-402.285715 329.142857-7.314285 7.314286v1.828572c-1.828571 1.828571-3.657143 5.485714-3.657143 7.314285v1.828572c0 3.657143-1.828571 5.485714-1.828572 9.142857v475.428571c0 20.114286 16.457143 36.571429 36.571429 36.571429h804.571428c20.114286 0 36.571429-16.457143 36.571429-36.571429V438.857143c-3.657143-3.657143-3.657143-5.485714-3.657143-9.142857zM261.485714 841.142857h-73.142857v-73.142857h73.142857v73.142857z m0-128h-73.142857v-73.142857h73.142857v73.142857z m0-128h-73.142857v-73.142857h73.142857v73.142857z m146.285715 256h-73.142858v-73.142857h73.142858v73.142857z m0-128h-73.142858v-73.142857h73.142858v73.142857z m146.285714 128h-73.142857v-73.142857h73.142857v73.142857z m281.6-193.828571L713.142857 768l-51.2-53.028571 58.514286-56.685715H480.914286v-73.142857h239.542857l-58.514286-56.685714L713.142857 475.428571l122.514286 120.685715c7.314286 7.314286 10.971429 16.457143 10.971428 25.6 0 9.142857-3.657143 20.114286-10.971428 25.6z"
                fill="#41B56F" p-id="14908"></path>
            </svg>
            <h3 class="text-[#41B56F] font-bold text-4xl">基地介绍</h3>
            <p class="text-gray-700 text-xl">智能农业，汇聚各大智慧蘑菇仓基地</p>
          </div>
        </div>
        <!-- <a href="javascript:;" class="text-gray-700 text-2xl flex items-center gap-1">
          查看更多 <span class="text-2xl">→</span>
        </a> -->
      </div>

      <!-- 天津宝坻基地（设计图：左文字 右图片） -->
      <div class="w-full rounded-3xl pb-24 mt-40 relative bg-[linear-gradient(180deg,#efefef_0%,#f8f8f800_100%)]">
        <div class="w-[50%] pl-16 pt-6 pb-16">
          <!-- 标题+定位图标 完全匹配设计图 -->
          <div class=" mb-4 flex items-center gap-2">
            <h4 class="text-4xl font-bold text-[#41B56F]">
              天津宝坻 · 生态升级
            </h4>
            <!-- 替换成设计图同款定位图标，不再用温泉表情 -->
            <img src="@/assets/about/Vector.png" alt="">
          </div>

          <p class="text-black text-sm leading-relaxed mb-6 text-indent">
            依托 198 亩农业资源两期开发多品类栽培，探索「低空经济 + 智慧云仓」融合新模式，打造乡村振兴样板。</p>
          <!-- 按钮完全匹配设计图：圆角绿色+播放图标 -->
          <div @click="goDetail(1)" class="relative">
            <img src="@/assets/about/Frame_131.png" class="absolute top-0 left-0" alt="">
            <span class="absolute z-10 text-white text-sm top-4 left-8">查看详情 </span>
          </div>
        </div>
        <div class="absolute top-[-200px] right-[-140px] w-[55%] flex justify-center items-center h-w-full">
          <img src="@/assets/about/image_17.png" alt="天津宝坻" class="scale-[0.9]">
        </div>
      </div>

      <!-- 重庆江津基地（设计图：左图片 右文字，和天津左右相反） -->

      <div
        class="w-full rounded-3xl pb-24 mt-40 relative bg-[linear-gradient(180deg,#efefef_0%,#f8f8f800_100%)] clearfix">
        <div class="absolute top-[-140px] left-[-160px] w-[55%] flex justify-center items-center h-w-full">
          <img src="@/assets/about/新对话_(1)_1.png" alt="重庆江津基地" class="scale-[0.9]">
        </div>
        <div class="w-[45%] pr-6 pt-24 pb-16 float-right">
          <!-- 标题+定位图标 完全匹配设计图 -->
          <div class=" mb-4 flex items-center gap-2">
            <h4 class="text-4xl font-bold text-[#41B56F]">
              重庆江津基地 · 工厂化典范
            </h4>
            <!-- 替换成设计图同款定位图标，不再用温泉表情 -->
            <img src="@/assets/about/Vector.png" alt="">
          </div>

          <p class="text-black text-sm leading-relaxed mb-6 text-indent">
            全流程自动化 + 智能环控，年产食用菌超 6 万吨、占据西南食用菌市场近七成份额。</p>
          <!-- 按钮完全匹配设计图：圆角绿色+播放图标 -->
          <div @click="goDetail(2)" class="relative">
            <img src="@/assets/about/Frame_131.png" class="absolute top-0 left-0" alt="">
            <span class="absolute z-10 text-white text-sm top-4 left-8">查看详情 </span>
          </div>
        </div>
      </div>

      <!-- 3. 客户案例区 -->
      <!-- <div class="mb-8 mt-10">
        <h3 class="text-5xl font-bold text-[#41B56F] text-center mb-3">客户案例</h3>
        <p class="text-[#666] text-base text-center mb-8">
          我们致力于与合作伙伴携手共赢，以诚信立业，以品质取胜，共创食用菌产业美好未来。
        </p>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="bg-white rounded-lg overflow-hidden shadow-sm">
            <img src="@/assets/about/Rectangle_56.png" alt="上林县试验工场 - 舞茸菌" class="w-full h-auto object-cover">
            <div class="p-4">
              <h4 class="font-bold text-[#41B56F] text-2xl mb-1">上林县试验工场 - 舞茸菌</h4>
              <p class="text-gray-500 text-sm">2022年5月，1号试验工场 种植舞茸菌，取得成功。</p>
            </div>
          </div>

          <div class="bg-white rounded-lg overflow-hidden shadow-sm">
            <img src="@/assets/about/Rectangle_57.png" alt="武鸣县试验工场 - 秀珍菇" class="w-full h-auto object-cover">
            <div class="p-4">
              <h4 class="font-bold text-[#41B56F] text-2xl mb-1">武鸣县试验工场 - 秀珍菇</h4>
              <p class="text-gray-500 text-sm">2023年7月，武鸣县秀珍 菇实验，超实售。</p>
            </div>
          </div>
        </div>
      </div> -->
    </section>
  </div>
</template>

<script>
export default {
  name: "BasePage",
  methods: {
    goDetail(id) {
      this.$router.push(`/about/base/detail?id=${id}`);
    }
  }
}
</script>

<style scoped>
/* 基础过渡效果 */
button {
  border: none;
  cursor: pointer;
}
</style>